import { skipToken } from "@reduxjs/toolkit/query";
import type { FC } from "react";
import { useGetKnowledgeBaseQuery } from "../../../api/entities/knowledgeBase.js";
import { renderCrumbLabel } from "../../../app/navigation/crumbLabel.js";

/** Breadcrumb label for the knowledge base details page. */
export const KnowledgeBaseNameCrumbLabel: FC<{
  knowledgeBaseId: string | undefined;
}> = ({ knowledgeBaseId }) => {
  const result = useGetKnowledgeBaseQuery(knowledgeBaseId ?? skipToken);
  return renderCrumbLabel({
    hasValidId: knowledgeBaseId !== undefined,
    result,
    buildText: (knowledgeBase) => knowledgeBase.name,
    fallbackText: "Knowledge base",
  });
};
